import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'

import { IFormCollector } from 'core/classes/models/IFormCollector'
import { CrudStore } from 'core/types/crudStore'

export enum FormCollectorCacheKey {
  DataCollectorTable = 'data_collector_table',
}

class OnboardingFormCollectorApi {
  public getCrud(cacheKey: FormCollectorCacheKey) {
    return CrudStore.get<IFormCollector>(CrudStoreItem.FormCollector, cacheKey)
  }

  public triggerCrudOnChange(cacheKey: FormCollectorCacheKey) {
    this.getCrud(cacheKey).triggerOnChange()
  }
}

export const onboardingFormCollectorApi = new OnboardingFormCollectorApi()
